module.exports = __webpack_public_path__ + "static/img/je.e0932aed.svg";